module.exports = __webpack_public_path__ + "static/img/8.88d5f2bd.jpg";